import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//import axios from "axios";

const TodayMeetings = () => {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTodayMeetings = async () => {
    try {
      const res = await fetch(`${apiUrl}/lead/getTodayFollowUps`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      //  console.log("Fetched meetings:", data);
      setMeetings(data?.data);
    } catch (error) {
      console.error("Error fetching meetings", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodayMeetings();
  }, []);

  if (loading) return <p>Loading meetings...</p>;
  // console.log(meetings);
  return (
    <div className="card">
      <h4
        className="card-header  text-center pb-2"
        style={{ backgroundColor: "rgb(62, 72, 112)", color: "#f9f9f9" }}
      >
        Todo List({meetings.length})
      </h4>
      {/* <div className="card-body ">
        {meetings.length === 0 ? (
          <p>No meetings or call scheduled for today.</p>
        ) : (
          <ul className="list-group">
            {meetings.map((meeting) => (
              <Link to={`/DatelsLeads/${meeting.Lead.id}`}>
                {meeting.type === "meetingUpdate" ? (
                  <li
                    key={meeting.id}
                    className="list-group-item "
                    style={{
                      backgroundColor: "ghostwhite",
                      borderRadius: "5px",
                    }}
                  >
                    <i class="fa-solid fa-handshake-simple"></i>{" "}
                    <strong>{meeting?.Lead?.primaryContactName}</strong>
                    <br />
                    Time:{" "}
                    {new Date(meeting.meetingDateTime).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}{" "}
                    - Meeting Type: {meeting.meetingType}
                    <br />
                    {meeting.meetingType == "offline" &&
                      `Meeting Venue
: ${meeting.meetingVenue}`}
                  </li>
                ) : (
                  <li
                    key={meeting.id}
                    className="list-group-item "
                    style={{
                      backgroundColor: "#FFF2EB",
                      borderRadius: "5px",
                    }}
                  >
                    <i class="fa-solid fa-phone"></i>{" "}
                    <strong>{meeting?.Lead?.primaryContactName}</strong>
                    <br />
                    Time:{" "}
                    {new Date(meeting.callDateTime).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}{" "}
                    - Contact Type: {meeting.contactType}
                    <br />
                  </li>
                )}{" "}
              </Link>
            ))}
          </ul>
        )}
      </div> */}

      <div className="card-body">
        {meetings.length === 0 ? (
          <p>No meetings or call scheduled for today.</p>
        ) : (
          <ul className="list-group">
            {meetings.map((meeting) =>
              meeting.type === "meetingUpdate" ? (
                <li
                  key={meeting.id}
                  className="list-group-item"
                  style={{
                    backgroundColor: "ghostwhite",
                    borderRadius: "5px",
                  }}
                >
                  <i className="fa-solid fa-handshake-simple"></i>{" "}
                  <strong>{meeting?.Lead?.primaryContactName}</strong>
                  <br />
                  Time:{" "}
                  {new Date(meeting.meetingDateTime).toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}{" "}
                  - Meeting Type: {meeting.meetingType}
                  <br />
                  {meeting.meetingType === "offline" &&
                    `Meeting Venue: ${meeting.meetingVenue}`}
                </li>
              ) : (
                <li
                  key={meeting.id}
                  className="list-group-item"
                  style={{
                    backgroundColor: "#FFF2EB",
                    borderRadius: "5px",
                  }}
                >
                  <i className="fa-solid fa-phone"></i>{" "}
                  <strong>{meeting?.Lead?.primaryContactName}</strong>
                  <br />
                  Time:{" "}
                  {new Date(meeting.callDateTime).toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}{" "}
                  - Contact Type: {meeting.contactType}
                </li>
              )
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default TodayMeetings;
